import axios from "axios";
// live url::: https://api-dashboard.nordmann-inkasso.de

// local url ::: https://api-dashboard.nordmann-inkasso.de

const API = axios.create({
  baseURL: `https://api-dashboard.nordmann-inkasso.de
/api`,
  withCredentials: true, // important for cookies (refresh token)
});
// https://api-dashboard.nordmann-inkasso.de

// Request interceptor -> always attach access token https://api-dashboard.nordmann-inkasso.de

API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor -> handle expired access token
API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If 401 error & not already retried -> try refreshing token
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const { data } = await axios.post(
          `https://api-dashboard.nordmann-inkasso.de
/api/auth/refresh`,
          {},
          { withCredentials: true } // send cookie
        );

        localStorage.setItem("accessToken", data.token);

        API.defaults.headers.Authorization = `Bearer ${data.token}`;
        originalRequest.headers.Authorization = `Bearer ${data.token}`;


        return API(originalRequest); // retry failed request
      } catch (refreshError) {
        console.error("Refresh token failed:", refreshError);
        localStorage.removeItem("accessToken");
        window.location.href = "/"; // redirect to login
      }
    }

    return Promise.reject(error);
  }
);

export default API;
export const BASE_URL = `https://api-dashboard.nordmann-inkasso.de
/api`;
